
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"290","height":"272","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".2"}},[_c('path',{attrs:{"d":"M-59.224.644h-89.507l354.115 357.049L290 353.78 150.604 213.895 290 70.097h-84.616L104.628 167.92l-22.5-21.032L222.993.644h-87.061L38.109 97.976-59.224.645z","fill":"#ADCD39"}}),_c('path',{attrs:{"d":"M-118.406 70.097H-204l138.418 139.885L-204 346.933h85.594l96.844-91.953L.937 274.545-136.992 414.43h85.594l142.33-139.885-209.338-204.448z","fill":"#459042"}})])])
          )
        }
      }
    